// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as ErrorUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as AuthVm$PorterinFeature from "../../../../../view-model/AuthVm.mjs";
import * as CookieStore$PorterinFeature from "../../../../../../fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../../../domain/repo/AuthRepoManager.mjs";
import * as CustomErrorUtils$PorterinFeature from "../../../../../../order-review/domain/helpers/CustomErrorUtils.mjs";

function initialFormState(mobile) {
  return {
          mobile: mobile,
          email: ""
        };
}

function setInitialFormState(initial_mobile_input) {
  return {
          mobile: initial_mobile_input,
          email: ""
        };
}

function onFormSubmit(output, callbacks, setResponse, set_auth_state, set_user, whatsapp_consent, prefill) {
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  var webTrackingId = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.web_tracking_id);
  var form_data_mobile = output.mobile;
  var form_data_email = output.email;
  Curry._1(set_user, {
        auth_token: undefined,
        mobile: form_data_mobile,
        name: AuthVm$PorterinFeature.prefillName(prefill),
        requirement_type: AuthVm$PorterinFeature.prefillRequirementType(prefill),
        email: form_data_email,
        whatsapp_consent: whatsapp_consent
      });
  ApiUtils$Catalyst.handleAPIRequest((function (param) {
          return Curry._3(RepoInstance.customerSignUp, webTrackingId, form_data_mobile, form_data_email);
        }), (function (_data) {
          Curry._1(callbacks.notifyOnSuccess, undefined);
          Curry._1(set_auth_state, (function (param) {
                  return /* OtpValidationV2 */6;
                }));
        }), (function (error) {
          var match = CustomErrorUtils$PorterinFeature.getErrorEntity(error);
          var exit = 0;
          if (typeof match === "number" || match.TAG !== /* UnprocessedEntity */1) {
            exit = 1;
          } else {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          if (exit === 1) {
            Curry._1(setResponse, (function (param) {
                    return {
                            TAG: /* Error */1,
                            _0: ErrorUtils$Catalyst.resolveError(error)
                          };
                  }));
          }
          Curry._1(callbacks.notifyOnFailure, error);
        }));
}

export {
  initialFormState ,
  setInitialFormState ,
  onFormSubmit ,
}
/* CookieUtils-PorterinFeature Not a pure module */
